<template>
  <div v-if="$store.getters.shelvingsSwitch">
    <v-dialog v-model="dialog">
      <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="e1 = 1" class="btn btn--ghost-primary icon icon--right u-margin-top-0">
            {{ label }} <i class="icon-edit"></i>
          </button>
      </template>

      <div class="pt-8 pr-8 pb-8 pl-8 u-bg--white">
        <v-stepper v-model="e1" alt-labels>
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">{{ $t('configurator.accessories_modal.wire_plate') }}</v-stepper-step>
            <v-divider :class="e1 >= 2 ? 'complete':''"></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2">{{ $t('configurator.accessories_modal.single_double') }}</v-stepper-step>
            <v-divider :class="e1 >= 3 ? 'complete':''"></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3">{{ $t('configurator.accessories_modal.shelves') }}</v-stepper-step>
            <v-divider :class="e1 >= 4 ? 'complete':''"></v-divider>
            <v-stepper-step :complete="e1 > 4" step="4">{{ $t('configurator.accessories_modal.front_stops') }}</v-stepper-step>
            <v-divider :class="e1 >= 5 ? 'complete':''"></v-divider>
            <v-stepper-step step="5">{{ $t('configurator.accessories_modal.dividers') }}</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <div class="pt-12">
                <v-form>
                  <v-radio-group v-model="shelvesWirePlate" required row>
                    <v-radio
                      :label="$t('configurator.accessories_modal.wire_shelves')"
                      color="black"
                      value="wire"
                      class="onex-form"
                    ></v-radio>
                    <v-radio
                      :label="$t('configurator.accessories_modal.plate_shelves')"
                      color="black"
                      value="plate"
                      class="onex-form"
                    ></v-radio>
                    <div>
                     <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://media.schott.com/api/public/content/f8db24064e9d42b1b18bb2a1015b23aa?v=1a961c40"
                        class="u-vertical-align-top"
                      >
                        {{ $t('configurator.accessories_modal.wire_plate_link') }}
                      </a>
                    </div>
                  </v-radio-group>
                  <v-radio-group v-model="postsFrontBack" required row>
                    <v-radio
                      :label="$t('configurator.accessories_modal.posts_front')"
                      color="black"
                      value="front"
                      class="onex-form"
                    ></v-radio>
                    <v-radio
                      :label="$t('configurator.accessories_modal.posts_back')"
                      color="black"
                      value="back"
                      class="onex-form"
                    ></v-radio>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on"><i class="icon-info u-vertical-align-top"></i></span>
                      </template>
                      <span>{{ $t('configurator.accessories_modal.post_info') }}</span>
                      <v-row>
                        <v-img
                          :src="require('@/assets/back.png')"
                          contain
                          width="475px"
                          height="275px"
                        >
                        </v-img>
                        <v-img
                          :src="require('@/assets/front.png')"
                          contain
                          width="475px"
                          height="275px"
                        >
                        </v-img>
                      </v-row>
                    </v-tooltip>
                  </v-radio-group>
                  <v-switch v-if="this.$store.state.shelvesWirePlate== 'wire'"
                    v-model="gravitySheetSwitch"
                    inset
                    :label="$t('configurator.accessories_modal.gravity')"
                    color="black"
                  ></v-switch>
                  <v-switch v-if="this.$store.state.postsFrontBack== 'front' "
                    v-model="containerStops"
                    inset
                    :label="$t('configurator.accessories_modal.container')"
                    color="black"
                  ></v-switch>
                </v-form>
              </div>
              <div class="actions pt-6 u-text-align-center">
                <div class="btn btn--secondary"
                  @click="(dialog = false), resetAccessoireParameters()">
                  {{ $t('common.cancel') }}
                </div>
                <div class="btn btn--primary ml-2"
                  @click="e1 = 2">
                  {{ $t('common.next_step') }}
                </div>
              </div>
            </v-stepper-content>
            <v-stepper-content step="2">
              <div class="pt-12">
                <v-radio-group v-model="shelvesSingleDouble" required row>
                  <v-radio
                      v-if="this.$store.state.article.slice(-2) !== '45'"
                      label="Only single shelves"
                      color="black"
                      value="single"
                      class="onex-form"
                  ></v-radio>
                    <v-radio
                      label="Use double shelves where possible"
                      color="black"
                      value="double"
                      class="onex-form"
                    ></v-radio>
                </v-radio-group>
              </div>
              <div class="actions pt-6 u-text-align-center">
                <div class="btn btn--secondary"
                  @click="e1 = 1">
                  {{ $t('common.previous_step') }}
                </div>
                <div class="btn btn--primary ml-2"
                  @click="e1 = 3">
                  {{ $t('common.next_step') }}
                </div>
              </div>
            </v-stepper-content>
            <v-stepper-content step="3">
              <div class="pt-12">
                <v-form>
                  <label class="onex-form label-select">
                    Number Of Shelves Per Door
                  </label>
                  <v-select
                    v-model="shelvesPerDoor"
                    :items="[1, 2, 3, 4, 5, 6, 7, 8]"
                    label=""
                    class="onex-form select"
                  ></v-select>
                </v-form>
              </div>
              <div class="actions pt-6 u-text-align-center">
                <div class="btn btn--secondary"
                  @click="e1 = 2">
                  {{ $t('common.previous_step') }}
                </div>
                <div class="btn btn--primary ml-2"
                  @click="e1 = 4">
                  {{ $t('common.next_step') }}
                </div>
              </div>
            </v-stepper-content>
            <v-stepper-content step="4">
              <div class="pt-12">
                <v-form>
                  <label class="onex-form label-select">
                    Number Of Front Stops Per Shelf
                  </label>
                  <v-select  v-if="this.$store.state.shelvesWirePlate == 'wire'"
                    v-model="frontStopsPerShelf"
                    :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]"
                    label=""
                    class="onex-form select"
                  ></v-select>
                  <v-select  v-if="this.$store.state.shelvesWirePlate == 'plate'"
                    v-model="frontStopsPerShelf"
                    :items="[0, 1]"
                    label=""
                    class="onex-form select"
                  ></v-select>
                </v-form>
              </div>
              <div class="actions pt-6 u-text-align-center">
                <div class="btn btn--secondary"
                  @click="e1 = 3">
                  {{ $t('common.previous_step') }}
                </div>
                <div class="btn btn--primary ml-2"
                  @click="e1 = 5">
                  {{ $t('common.next_step') }}
                </div>
              </div>
            </v-stepper-content>
            <v-stepper-content step="5">
              <div class="pt-12">
                <v-form>
                  <label class="onex-form label-select">
                    Number Of Dividers Per Shelf
                  </label>
                  <v-select
                    v-model="dividersPerShelf"
                    :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]"
                    label=""
                    class="onex-form select"
                  ></v-select>
                </v-form>
              </div>
              <div class="actions pt-6 u-text-align-center">
                <div class="btn btn--secondary"
                  @click="e1 = 4">
                  {{ $t('common.previous_step') }}
                </div>
                <div class="btn btn--primary ml-2"
                  @click="dialog = false">
                  {{ $t('common.done') }}
                </div>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'buttonLabel',
  ],
  data: function () {
    return {
      e1: 1,
      dialog: false,
      label: this.buttonLabel
    }
  },
  methods: {
    resetAccessoireParameters() {
      this.$store.commit("setShelvesPerDoor", 5);
      this.$store.commit("setShelvesWirePlate", "wire");
      this.$store.commit("setGravitySheetSwitch",false)
      this.$store.commit("setPostsFrontBack", "back");
      if (this.$store.state.coldroomSystem == 'classic') {
        this.$store.commit("setShelvesSingleDouble", "single");
      } else {
        this.$store.commit("setShelvesSingleDouble", "double");
      }
      this.$store.commit("setContainerStops", false);
      this.$store.commit("setFrontStopsPerShelf", 6);
      this.$store.commit("setDividersPerShelf", 5);
    },
  },
  computed: {
    showResetButton: {
      get() {
        if (this.$store.state.coldroomSystem == 'classic') {
          if (['45','90'].includes(this.$store.state.article.slice(-2))){
            if (
              this.$store.state.shelvesPerDoor !== 5 ||
              this.$store.state.shelvesWirePlate !="wire" ||
              this.$store.state.gravitySheetSwitch != false ||
              this.$store.state.postsFrontBack !=  "back" ||
              this.$store.state.shelvesSingleDouble != "double" ||
              this.$store.state.containerStops != false ||
              this.$store.state.frontStopsPerShelf != 6 ||
              this.$store.state.dividersPerShelf != 5
              ) {
              return true;
            } else {
              return false;
            }
          } else {
            if (
              this.$store.state.shelvesPerDoor !== 5 ||
              this.$store.state.shelvesWirePlate !="wire" ||
              this.$store.state.gravitySheetSwitch != false ||
              this.$store.state.postsFrontBack !=  "back" ||
              this.$store.state.shelvesSingleDouble != "single" ||
              this.$store.state.containerStops != false ||
              this.$store.state.frontStopsPerShelf != 6 ||
              this.$store.state.dividersPerShelf != 5
              ) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          if (
            this.$store.state.shelvesPerDoor !== 5 ||
            this.$store.state.shelvesWirePlate !="wire" ||
            this.$store.state.gravitySheetSwitch != false ||
            this.$store.state.postsFrontBack !=  "back" ||
            this.$store.state.shelvesSingleDouble != "double" ||
            this.$store.state.containerStops != false ||
            this.$store.state.frontStopsPerShelf != 6 ||
            this.$store.state.dividersPerShelf != 5
            ) {
            return true;
          } else {
            return false;
          }
        }
      },
    },
    shelvesPerDoor: {
      get() {
        return this.$store.state.shelvesPerDoor;
      },
      set(value) {
        this.$store.commit("setShelvesPerDoor", value);
      },
    },
    shelvesWirePlate: {
      get() {
        return this.$store.state.shelvesWirePlate;
      },
      set(value) {
        this.$store.commit("setShelvesWirePlate", value);
      },
    },
    postsFrontBack: {
      get() {
        return this.$store.state.postsFrontBack;
      },
      set(value) {
        this.$store.commit("setPostsFrontBack", value);
        if (value=='back'){this.$store.commit("setContainerStops", false)}
      },
    },
    gravitySheetSwitch: {
      get() {
        return this.$store.state.gravitySheetSwitch;
      },
      set(value) {
        this.$store.commit("setGravitySheetSwitch", value);
      },
    },
    shelvesSingleDouble: {
      get() {
        return this.$store.state.shelvesSingleDouble;
      },
      set(value) {
        this.$store.commit("setShelvesSingleDouble", value);
      },
    },
    containerStops: {
      get() {
        return this.$store.state.containerStops;
      },
      set(value) {
        this.$store.commit("setContainerStops", value);
      }
    },
    frontStopsPerShelf: {
      get() {
        return this.$store.state.frontStopsPerShelf;
      },
      set(value) {
        this.$store.commit("setFrontStopsPerShelf", value);
      }
    },
    dividersPerShelf: {
      get() {
        return this.$store.state.dividersPerShelf;
      },
      set(value) {
        this.$store.commit("setDividersPerShelf", value);
      }
    },
  },
};
</script>
